<template>
    <v-row>
        <v-col>            
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                                                    
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between">                                       
                                    <!--<img class="ma-1- mx-0"  src="/icon-small.jpg" height="36" />-->
                                    <h5 class="ma-1 mt-6" >Capacity Utilization Report</h5> 
                                </div>                                 
                                <div class="d-flex flex"></div>
                                <div style="width: 350px;"> 
                                    <v-menu                                    
                                        ref="calcDatepicker"
                                        v-model="calculationDatepickerFrom"
                                        :close-on-content-click="false"
                                        
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{on, attrs}">
                                            <v-text-field
                                            class="ma-4 mb-0 d-flex flex"
                                                label='From'
                                                dense
                                                outlined
                                                v-model="calculationDateFrom"                                              
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details    
                                                :clearable="true"                                                       
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="calculationDateFrom" :max="datepickerMaxLimit" scrollable>                    
                                        </v-date-picker>
                                    </v-menu>
                                </div>     
                                <div style="width: 350px;"> 

                                    <v-menu                                    
                                    ref="calcDatepicker"
                                    v-model="calculationDatepickerTo"
                                    :close-on-content-click="false"
                                    
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{on, attrs}">
                                        <v-text-field
                                        class="ma-4 mb-0 d-flex flex"                                            
                                            label='To'
                                            dense
                                            outlined
                                            v-model="calculationDateTo"                                              
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            hide-details    
                                            :clearable="true"                                                       
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="calculationDateTo" :max="datepickerMaxLimit" scrollable>                    
                                    </v-date-picker>
                                </v-menu>
                                </div>                         
                                
                                <v-btn class="maz-4 mt-4" dark color="primary" @click="getData" :loading="progressStatsLoading">
                                        <v-icon>mdi-reload</v-icon>
                                        Reload
                                </v-btn>
                            </div>
                        </v-card-title>                                        
                        <v-progress-linear
                            :active="progressStatsLoading"
                            :indeterminate="progressStatsLoading"
                            absolute
                            bottom
                            color="deep-purple accent-4"
                        />
                    </base-card>
                    <!--<div class="d-block text-center mt-8"> 
                        <v-progress-circular
                        v-if="progressStatsLoading"
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                        <div v-else >no cache entries found </div>
                    </div>-->
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pl-2">
                            <v-card-title>Total Utilization</v-card-title>
                        </div>                        
                    </base-card>
                </v-col>
            </v-row>  
            <v-row > 
                <!--<v-col cols="12">
                    <div class="body-2" style="color: #d10d13">
                        {{o.title}}
                    </div> 
                </v-col>-->
                <v-col cols="3">
                    <card-dashboard title="No of AdPoints" :primaryvalue="total_adpoints" ></card-dashboard>
                </v-col>
                <v-col cols="3">
                    <card-dashboard title="Total Impressions" :primaryvalue="total_capacity" ></card-dashboard>
                </v-col>
                <v-col cols="3">
                    <card-dashboard title="Available Impressions" :primaryvalue="available_impressions" ></card-dashboard>
                </v-col>
                <v-col cols="3">
                    <card-dashboard title="Utilization" :primaryvalue="utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                </v-col>                
            </v-row>
            <v-tabs v-model="tabs_selection" color="#FFF" class="mb-3 mt-3">
                <v-tab style="text-transform: none;"  ><v-card-title>Networks Utilization</v-card-title></v-tab>
                <v-tab style="text-transform: none;" ><v-card-title>Clusters Utilization</v-card-title></v-tab>
            </v-tabs>
            <template v-if="tabs_selection==0">
                <v-row  v-for="o in networks" :key="o.id"> 
                    <!--<v-col cols="12">
                        <div class="body-2" style="color: #d10d13">
                            {{o.title}}
                        </div> 
                    </v-col>-->
                    <v-col cols="3">
                        <card-dashboard title="No of AdPoints" :primaryvalue="o.total_adpoints" :secondaryvalue="o.title" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Total Impressions" :primaryvalue="o.total_capacity" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Available Impressions" :primaryvalue="o.available_impressions" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Utilization" :primaryvalue="o.utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                    </v-col>                
                </v-row> 
            </template>      
            <template v-if="tabs_selection==1">
                <v-row v-for="o in clusters" :key="o.id"> 
                    <!--<v-col cols="12">
                        <div class="body-2" style="color: #d10d13">
                            {{o.title}}
                        </div> 
                    </v-col>-->
                    <v-col cols="3">
                        <card-dashboard title="No of AdPoints" :primaryvalue="o.total_adpoints" :secondaryvalue="o.title" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Total Impressions" :primaryvalue="o.total_capacity" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Available Impressions" :primaryvalue="o.available_impressions" ></card-dashboard>
                    </v-col>
                    <v-col cols="3">
                        <card-dashboard title="Utilization" :primaryvalue="o.utilization_pct" valueformatting="x" unit="%" ></card-dashboard>
                    </v-col>                
                </v-row> 
            </template>                  
            
            <!--<v-row>
                <v-col cols="12">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pl-2">
                            <v-card-title>Networks Utilization</v-card-title>
                        </div>                        
                    </base-card>
                </v-col>
            </v-row>  -->
            
            <!--<v-row>
                <v-col cols="12">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pl-2">
                            <v-card-title>Clusters Utilization</v-card-title>
                        </div>                        
                    </base-card>
                </v-col>
            </v-row>  -->
            

            <v-snackbar
                v-model="mysnackbar"
                :timeout="4000"
                bottom
                tile
                color="red"            
                >                
            </v-snackbar>
        </v-col>
    </v-row>
</template>

<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
import moment from "moment";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList";
import {GGanttChart, GGanttRow} from 'vue-ganttastic';
import { GChart } from 'vue-google-charts/legacy';
import CardDashboard from "@/components/campaigns/CardDashboard";
import ReportRuleComponent from "@/components/campaigns/campaign-report-rule-component";
import {parseDate, formatDate} from '@/core/date-utils.js';
import { integerFormatting } from '@/core/number-utils.js'
// import Gantt from '@salamander.be/vue-gantt/src/components/gantt.vue';
import {
    gradientLineChart,
    salesByCountries,
    visitorsAnalytic
} from '@/data/sales2';
import {
  analyticOne,
  analyticTwo,
  analyticThree,
  analyticFour,
  analyticFive,
} from "@/data/analytic2";

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoints Management'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList    ,
        GGanttChart,
        GGanttRow,
        GChart,
        CardDashboard,
        "report-rule-component": ReportRuleComponent
       // Gantt  
    },
    data() {
        return {            
            mysnackbar: false,    
            mysnackbar_msg: "",       
            progressStatsLoading: true,   
            tabs_selection: null,
            
            calculationDateFrom: null,
            calculationDatepickerFrom: null,
            calculationDateTo: null,
            calculationDatepickerTo: null,
            datepickerMaxLimit: null,

            total_adpoints: null,
            total_capacity: null,
            available_impressions: null,
            utilization_pct: null,

            networks: [],

            clusters: [],                        
        }
    },
    filters: {

    },
    watch: {
      
    },
    computed: {

    },
    methods: {
        
        async exportDocument(selectedCampaign) {
            
            await new Promise(resolve => setTimeout(resolve, 12000));
            this.progressStatsLoading = false;
            //this.mysnackbar=true;
            this.progressStatsLoading=false;
        },

        async getData() {
            this.progressStatsLoading=true;
            try {
                const rsp = await srvApi.post(PATH.REPORTING_UTILIZATION, {
                    startDate: this.calculationDateFrom,
                    endDate: this.calculationDateTo
                });            
                
                this.total_adpoints = rsp.data.total_adpoints;
                this.total_capacity = rsp.data.total_capacity;
                this.available_impressions = rsp.data.available_impressions;
                this.utilization_pct = rsp.data.utilization_pct;

                this.networks.splice(0, this.networks.length);
                this.networks.push(...rsp.data.networks);

                this.clusters.splice(0, this.clusters.length);
                this.clusters.push(...rsp.data.clusters);

            } catch (error) {
                this.mysnackbar_msg= "Error: " + (error.message || error.msg || "Server Error");
                this.mysnackbar=true;
            }
            finally {
                this.progressStatsLoading=false;
            }
            
        }

        
    },
    async created() {
        let today = new Date();
        let sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        let oneDayAgo = new Date();
        oneDayAgo.setDate(oneDayAgo.getDate() - 1);
        let thirtyDaysAfter = new Date();
        thirtyDaysAfter.setDate(thirtyDaysAfter.getDate() + 30);
        this.calculationDateFrom = sevenDaysAgo.toISOString().substring(0,10);
        this.calculationDateTo = oneDayAgo.toISOString().substring(0,10);
        this.datepickerMaxLimit = thirtyDaysAfter.toISOString().substring(0,10);
    },
    async mounted() {
        //await new Promise(resolve => setTimeout(resolve, 12000));
        // const basicData = await srvApi.get(PATH.NETWORK_ASOPTIONS);
        // this.networkOptions.push(...basicData.data.map(i=>({value: i.extra.code, text: i.text})));

        // if(this.$route.params.code) {
        //     this.code = this.$route.params.code;
        // }      
        // else {
        //     if(this.networkOptions.length>0) {
        //         this.code = this.networkOptions[0].value
        //     }
        // }  
        await this.getData();
        
        //this.mysnackbar=true;
        this.progressStatsLoading=false;

        /*
        let ff = this.filterfields.find(i=>i.selectvalue === "brand");        
        if(ff) {
            const rsp = await api.brand.getAll();            
            ff.listItems = rsp.data.map(i=> {return {selectvalue: i.code, selecttext: i.title}});
        }
        */
    }
}
</script>
<style lang="scss" scoped>

.v-card__title {
    color: #FFF
}

.v-application.primary--text {
    color: #FFF
}

.active {
       color: #222222 !important;
       background-color: #ffff !important;
    }
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -10px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

.metrics-griditem {
    //background-color: red;
    //margin-top: -10px;
    
    //border: 2px red solid;
}

.v-card .v-list-item {
    // color: #304156 !important;
}

</style>
